import { IonCard } from "@ionic/react";
import { ComponentProps, PropsWithChildren } from "react";

import styles from "@components/Container.module.css";

type Props = PropsWithChildren<
  Omit<ComponentProps<typeof IonCard>, "button" | "children" | "color"> & {
    className?: string;
  }
>;

const Container = ({ children, className, ...ionCardProps }: Props) => {
  const wrapperStyles = [styles.container];

  if (className) wrapperStyles.push(className);

  const isButton = ionCardProps.routerLink === undefined && ionCardProps.onClick !== undefined;

  return (
    <IonCard {...ionCardProps} button={isButton} className={wrapperStyles.join(" ")}>
      {children}
    </IonCard>
  );
};

export default Container;
